import React, { Component } from "react";
import { withRedux } from "helpers";
import { Prompt } from "react-router";
import { cloneDeep } from "lodash";
import { FlexRight, FlexRow, FlexColumn, Button, Modal, P } from "appStyles";
import styled, { css } from "react-emotion";
import AlertModal from "../Tools/AlertModal";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import CancelIcon from "@material-ui/icons/Cancel";
import { toast, ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import WebIcon from "../../pages/Web/WebIcon";

const row = css`
  display: flex;
  flex-flow: row wrap;
  flex: 0 1 auto;
`;
const col = css`
  flex: 0 0 92%;
  margin: auto 8%;
  display: flex;
  justify-content: flex-end;
  @media only screen and (min-width: 480px) {
    margin-left: 0%;
    margin-right: 0%;
    text-align: center;
  }
`;

const inlineBlock = css`
  display: inline-block;
`;

class SaveProgress extends Component {
  state = {
    confirmDiscard: false,
  };

  componentDidUpdate(prevProps) {
    const prevTemplateId = prevProps.platformInfo.display.templateId;
    const nextTemplateId = this.props.platformInfo.display.templateId;
    const { confirmDiscard } = this.state;

    // check if we are switching template
    if (
      this.hasChanged() &&
      !confirmDiscard &&
      prevTemplateId !== nextTemplateId
    ) {
      const { activeApp } = this.props;
      this.props.actions.setTemplate(activeApp.id, prevTemplateId);
      this.toggleWarning();
    }
  }

  componentWillUnmount() {
    if (this.hasChanged()) this.discardChange();
  }

  /**
   * use the below methods when appLirary is refactored to map by id
   */
  businessHasChanged = () => {
    const { activeApp, appLibrary, business } = this.props;

    const prevApp = appLibrary.applications[activeApp.id];
    const prevBusiness = prevApp ? prevApp.business : {};

    return JSON.stringify(prevBusiness) !== JSON.stringify(business);
  };

  Msg = (props) => {
    const { message } = props;
    return (
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ marginRight: "10px" }}>
            {" "}
            <WebIcon
              iconName={"checkMark"}
              useColor={true}
              size={"16px"}
              hover={false}
              className={inlineBlock}
              customColor={"#4caf50"}
            />
          </div>
          <p>{message}</p>
        </div>
      </div>
    );
  };

  notify = () => {
    toast(this.Msg({ message: "👍🏼 Changes saved!" }), {
      position: "bottom-right",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
    });
  };

  dealsHasChanged = () => {
    const { appLibrary, deals } = this.props;

    const prevDeals = appLibrary.deals;

    return JSON.stringify(prevDeals) !== JSON.stringify(deals);
  };

  punchCardHasChanged = () => {
    const { appLibrary, punchCard } = this.props;

    const prevPunchCard = appLibrary.punchCard;

    return JSON.stringify(prevPunchCard) !== JSON.stringify(punchCard);
  };

  rewardsHasChanged = () => {
    const { appLibrary, rewards } = this.props;

    const prevRewards = appLibrary.rewards;

    return JSON.stringify(prevRewards) !== JSON.stringify(rewards);
  };

  appHasChanged = () => {
    const { activeApp, appLibrary } = this.props;

    const prevApp = appLibrary.applications[activeApp.id];
    // console.log("CHECKING IF APP HAS CHANGED!");
    // console.log(JSON.stringify(prevApp) !== JSON.stringify(activeApp));

    return JSON.stringify(prevApp) !== JSON.stringify(activeApp);
  };

  appViewHasChanged = () => {
    const { activeApp } = this.props;

    if (activeApp.unpublishedView)
      return (
        decodeURI(activeApp.unpublishedView) !== JSON.stringify(activeApp.view)
      );
  };

  hasChanged = () => {
    // compare business and unpublishedView and app
    return (
      this.businessHasChanged() ||
      this.appViewHasChanged() ||
      this.appHasChanged()
    );
    //this.dealsHasChanged() ||
    // this.rewardsHasChanged());
  };

  discardChange = () => {
    const { activeApp, appLibrary, callback, activeTemplate } = this.props;

    const prevApp = appLibrary.applications[activeApp.id];
    // console.log(prevApp);
    const prevDeals = appLibrary.deals;
    const prevRewards = appLibrary.rewards;
    const prevPunchCard = appLibrary.punchCard;
    const prevBusiness = prevApp ? prevApp.business : {};

    if (this.dealsHasChanged()) {
      this.props.actions.setDeals(cloneDeep(prevDeals));
    }

    if (this.rewardsHasChanged()) {
      this.props.actions.setRewards(cloneDeep(prevRewards));
    }

    if (this.punchCardHasChanged()) {
      this.props.actions.setPunchCards(cloneDeep(prevPunchCard));
    }

    if (this.businessHasChanged()) {
      this.props.actions.setBusiness(cloneDeep(prevBusiness));
    }

    if (this.appHasChanged()) {
      this.props.actions.setApplication(cloneDeep(prevApp));
    }

    if (this.appViewHasChanged()) {
      activeApp.unpublishedView &&
        this.props.actions.updateApplication(
          "view",
          JSON.parse(decodeURI(prevApp.unpublishedView))
        );
    }

    this.toggleWarning();
    callback && callback();
  };

  updateApplication = () => {
    let { activeApp, business, callback, activeTemplate } = this.props;
    console.log(activeTemplate);

    if (activeTemplate.type === "pictureCatalog") {
      activeTemplate.components[0].view.sections.forEach((section) => {
        var filteredNullImages = section.images.filter((image) => {
          return image.url !== null;
        });
        section.images = filteredNullImages;
      });
    }

    if (activeTemplate.type === "imageTitleText") {
      var filteredNullImages = activeTemplate.components[0].view.images.filter(
        (image) => {
          return image.url !== null;
        }
      );
      activeTemplate.components[0].view.images = filteredNullImages;
    }

    this.props.actions.putBusinessApp(business, activeApp).then(() => {
      this.notify();
    });
    this.props.actions.updateActiveEditor(null);

    // console.log("closing active editor modal");
    callback && callback();
  };

  toggleWarning = () => {
    const { confirmDiscard } = this.state;
    this.setState({ confirmDiscard: !confirmDiscard });
    this.props.actions.updateActiveEditor(null);
  };

  renderButtons = [
    <a
      key="cancelButton"
      variant="contained"
      // className={mdcButton}=
      style={{
        backgroundColor: "white",
        cursor: "pointer",
        color: "#1976d2",
        fontWeight: "500",
        lineHeight: "1.75",
        borderRadius: "4px",
        letterSpacing: "0.02857em",
        textTransform: "uppercase",
        fontSize: "0.9375rem",
      }}
      onClick={this.toggleWarning}
    >
      Cancel
    </a>,
    <a
      onClick={this.discardChange}
      // className={mdcButton}
      key="discardButton"
      variant="contained"
      style={{
        cursor: "pointer",
        backgroundColor: "white",
        color: "red",
        fontWeight: "500",
        lineHeight: "1.75",
        borderRadius: "4px",
        letterSpacing: "0.02857em",
        textTransform: "uppercase",
        paddingLeft: "10px",
        fontSize: "0.9375rem",
      }}
    >
      Discard
    </a>,
  ];

  render() {
    const { confirmDiscard } = this.state;
    const {
      appLibrary: { deleting },
    } = this.props;
    // console.log("actions");
    // JSON.stringify(this.props.actions);
    // console.log(this.props.actions);
    return (
      <FlexRight height={this.props.height}>
        <div>
          <ToastContainer
            position="bottom-center"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable={false}
            pauseOnHover
            transition={Slide}
            // style={{  }}
          />
        </div>
        <Prompt
          when={this.hasChanged() && !deleting}
          message="Are you sure you want to leave without saving?"
        />
        <AlertModal
          title="Confirm Discard"
          render={confirmDiscard}
          buttons={this.renderButtons}
        >
          <P>Are you sure you want to discard your changes?</P>
        </AlertModal>
        <div className={row}>
          <div className={col}>
            <FlexRow>
              <Button
                // className={mdcButton}
                style={{
                  width: "190px",
                  display: "inline-flex",
                  alignItems: "center",
                  margin: "0px 10px 0px 0px",
                  fontSize: "15px",
                  fontWeight: "bold",
                  fontStyle: "normal",
                  fontStretch: "normal",
                  lineHeight: "normal",
                  letterSpacing: "normal",
                  textTransform: "none",
                  boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
                }}
                background="#F17F7F"
                disabled={!this.hasChanged()}
                onClick={this.toggleWarning}
              >
                <CancelIcon style={{ marginRight: "5px" }}></CancelIcon>
                Discard Changes
              </Button>
              <Button
                disabled={!this.hasChanged()}
                onClick={this.updateApplication}
                background="#89D2D3"
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  fontStyle: "normal",
                  fontStretch: "normal",
                  lineHeight: "normal",
                  letterSpacing: "normal",
                  textTransform: "none",
                  width: "100px",
                  boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
                  display: "inline-flex",
                  alignItems: "center",
                  borderRadius: "5.5px",
                }}
              >
                <SaveAltIcon style={{ marginRight: "5px" }}></SaveAltIcon>
                Save
              </Button>
            </FlexRow>
          </div>
        </div>
      </FlexRight>
    );
  }
}

export default withRedux(SaveProgress);
